// Copyright © 2017-2020  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2>
        <v-card v-if="showSuccess">
          <v-card-title>
            <span class="display-1">Success</span>
          </v-card-title>
          <v-card-text>
            Your account has been successfully created, please check your email for an activation email.
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-card-title>
            <span class="display-1">Register</span>
          </v-card-title>
          <v-form v-model="formValid" ref="form">
            <v-card-text>
              <v-layout row>
                <v-text-field
                  label="Name"
                  required
                  :rules="[ruleRequired]"
                  v-model="credentials.userName"
                  v-on:keyup.enter="register()"
                  >
                </v-text-field>
                <v-menu open-on-hover left>
                  <v-btn icon slot="activator" tabindex="-1"><v-icon>help_outline</v-icon></v-btn>
                  <v-card><v-card-text>
                    The user's first and last name.
                  </v-card-text></v-card>
                </v-menu>
              </v-layout>
              <v-layout row>
                <v-text-field
                  label="Email"
                  :error-messages="errorEmail"
                  id="email"
                  required
                  v-model="credentials.email"
                  v-on:keyup.enter="register()"
                  :rules="[ruleRequired, ruleEmail]"
                ></v-text-field>
                <v-menu open-on-hover left>
                  <v-btn icon slot="activator" tabindex="-1"><v-icon>help_outline</v-icon></v-btn>
                  <v-card><v-card-text>
                    The user's email.
                  </v-card-text></v-card>
                </v-menu>
              </v-layout>
              <v-layout row>
                <v-text-field
                  label="Company Name"
                  required
                  :rules="[ruleRequired]"
                  v-model="credentials.orgName"
                  v-on:keyup.enter="register()"
                ></v-text-field>
                <v-menu open-on-hover left>
                  <v-btn icon slot="activator" tabindex="-1"><v-icon>help_outline</v-icon></v-btn>
                  <v-card><v-card-text>
                    The company name.
                  </v-card-text></v-card>
                </v-menu>
              </v-layout>
              <v-layout row>
                <v-text-field
                  label="Subdomain"
                  :error-messages="errorSubdomain"
                  required
                  :rules="[ruleRequired, ruleSubdomain]"
                  v-model="credentials.subdomain"
                  v-on:keyup.enter="register()"
                ></v-text-field>
                <v-menu open-on-hover left>
                  <v-btn icon slot="activator" tabindex="-1"><v-icon>help_outline</v-icon></v-btn>
                  <v-card><v-card-text>
                    The subdomain portion of the url. The user will access their account at <b>subdomain</b>.phototag.app.
                    Must be between 3 and 32 characters long.  May contain: a-z, 0-9, and "-".
                  </v-card-text></v-card>
                </v-menu>
              </v-layout>
              <v-layout row>
                <v-checkbox v-model="agreement" :rules="[ruleAgreement]">
                  <span slot="label">By creating an account, you agree to the PhotoTag <router-link :to="{name: 'termsOfService'}">Terms of Service</router-link>
                  and <router-link :to="{name: 'privacyPolicy'}">Privacy Policy</router-link>.</span>
                </v-checkbox>
              </v-layout>
            </v-card-text>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed dark color="primary" @click="register">Register</v-btn>
          </v-card-actions>
        </v-card>

      </v-flex>
    </v-layout>

  <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'
import axios from 'axios'
import Rules from 'vue-common/components/rules'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      agreement: false,
      credentials: {},
      errorText: '',
      errorEmail: '',
      errorSubdomain: '',
      formValid: true,
      ruleEmail: Rules.email,
      ruleRequired: Rules.required,
      ruleSubdomain: Rules.subdomain,
      showSuccess: false
    }
  },

  watch: {
    'credentials.subdomain': function () {
      this.credentials.subdomain = this.credentials.subdomain.toLowerCase()
      if (Rules.subdomain(this.credentials.subdomain) === true) {
        var org = {}
        org.subdomain = this.credentials.subdomain
        axios.post('/api/check/subdomain', org, {}).then(response => {
          this.errorSubdomain = ''
        }).catch(e => {
          this.errorSubdomain = 'This subdomain is not available'
        })
      }
    },

    'credentials.email': function () {
      if (Rules.email(this.credentials.email) === true) {
        var user = {}
        user.username = this.credentials.email
        axios.post('/api/check/email', user, {}).then(response => {
          this.errorEmail = ''
        }).catch(e => {
          this.errorEmail = 'This email is already in use'
        })
      }
    }
  },

  methods: {
    register: function () {
      this.$refs.form.validate()
      if (this.formValid && this.agreement) {
        console.log('valid')
        axios.post('/auth/registerorganization', this.credentials, {}).then(response => {
          this.showSuccess = true
        }).catch(e => {
          this.errorText = 'Invalid request'
          console.log(e)
        })
      }
    },

    ruleAgreement: function (value) {
      if (value) {
        return value
      } else {
        return 'You must read and consent before continuing.'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/RegisterForm.vue